import { render, staticRenderFns } from "./listFreeOpenCourse.vue?vue&type=template&id=fe36e47c&"
import script from "./listFreeOpenCourse.vue?vue&type=script&lang=js&"
export * from "./listFreeOpenCourse.vue?vue&type=script&lang=js&"
import style0 from "./listFreeOpenCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports